import { Component, Input } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'mg-info-tooltip',
  templateUrl: './info-tooltip.component.html',
  styleUrls: ['./info-tooltip.component.scss'],
  standalone: false
})
export class InfoTooltipComponent {
  @Input() description: string
  @Input() fullWidth = false
  @Input() iconClass = '!text-xs'
}
